<template>
    <div>
        <div class="navbar relstive" :class="{
            immersive: immersive === 'true',
            'whitebg-navbar': immersive === 'true' ? showWhiteBg : true,
            'show-navbar': immersive !== 'true' ? false : showNavbar,
            'show-menu': showMenu,
            down: immersive === 'true' ? false : direction === 'down',
            up: immersive === 'true' ? false : direction === 'up',
            animation:
                immersive === 'true' ? true : (!above72 && direction === 'down') || above72,
        }" style="z-index:9;" :style="{
    transform: immersive === 'true' ? 'unset' : translateYVal,
}">
            <div class="menu-mask" @click="toggleMenu"></div>
            <div class="nav-area-wrap" :style="{
                height: showMenu ? `${menuHeight}px` : clientWidth < 992 ? `64px` : `72px`,
            }">
                <div class="b-container" ref="menuContainer">
                    <div class="nav-area">
                        <div class="logo-area">
                            <div class="logo ml-md" @click="onClickMenu('top')">
                                <img class="logo" :src="immersive === 'true'
                                    ? showWhiteBg || (showMenu && clientWidth < 992)
                                        ? Logo
                                        : LogoWhite
                                    : Logo
                                    " mode="scaleToFill" />
                            </div>
                            <div class="pointer nav-menu mr-md row center v-center" @click="toggleMenu">
                                <div class="menu-icon2" style="width:24px; height:24px; margin-right:4px;">
                                    <span class="control-icon"></span>
                                    <span class="control-icon"></span>
                                    <span class="control-icon"></span>
                                </div>
                            </div>
                        </div>
                        <div :class="[clientWidth >= 992 ? 'nav-area-end' : 'nav-area-end-mobile']">
                            <div class="nav-list">
                                <ul>
                                    <li :class="{ active: activeNav === 'home' }">
                                        <span class="nav-item pointer" @click="onClickMenu('top')">首页</span>
                                    </li>
                                    <li :class="{
                                        active: activeNav === 'hardware',
                                    }">
                                        <span class="nav-item pointer" @click="onClickMenu('b')">场景智能化服务</span>
                                    </li>
                                    <li :class="{
                                        active: activeNav === 'newservice',
                                    }">
                                        <span class="nav-item pointer" @click="onClickMenu('g')">服务</span>
                                    </li>
                                    <li :class="{
                                        active: activeNav === 'content3d',
                                    }">
                                        <span class="nav-item pointer" @click="onClickMenu('c')">
                                            硬件设施服务
                                        </span>
                                    </li>
                                    <li :class="{ active: activeNav === 'servicecase' }">
                                        <span class="nav-item pointer" @click="onClickMenu('d')">
                                            全国运维服务
                                        </span>
                                    </li>
                                    <li :class="{ active: activeNav === 'company' }">
                                        <span class="nav-item pointer" @click="onClickMenu('e')">
                                            合作客户
                                        </span>
                                    </li>
                                    <li :class="{ active: activeNav === 'contact' }">
                                        <span class="nav-item pointer" @click="onClickMenu('f')">
                                            联系我们
                                        </span>
                                    </li>
                                   <!--  <li>
                                        <a class="nav-item pointer row v-center"
                                            href="https://cloud.komlin.com/komlinServicePotocol/#/pages/index/xiaolu_techer/"
                                            target="_blank">
                                            用户协议
                                        </a>
                                    </li> -->
                                </ul>
                            </div>

                            <div class="social-media">
                                <div class="icon-44 mr-md">
                                    <div @click="toggleQrcode" class="social-media-item pointer">
                                        <i class="iconfont icon-wechat"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="immersive !== 'true'" :style="{ height: clientWidth < 992 ? `64px` : `72px` }"></div>
    </div>
</template>

<script>
import { Logo, LogoWhite } from '@/constants/pics';

export default {
    name: 'navbar',

    components: {},

    props: ['immersive', 'toggleQrcode', 'scrollTop', 'scrollTo', 'direction', 'activeNav'],

    data() {
        return {
            Logo,
            LogoWhite,

            showMenu: false,

            menuHeight: 0,
            clientWidth: 0,
        };
    },

    computed: {
        showWhiteBg() {
            if (this.scrollTop <= 36) {
                return false;
            }
            return true;
        },

        above72() {
            if (this.scrollTop >= 0 && this.scrollTop < 72) {
                return false;
            }
            return true;
        },

        showNavbar() {
            if (this.above72 && !this.showMenu) {
                if (this.direction === 'down') {
                    return true;
                }
                if (this.direction === 'up' && this.scrollTop <= 0) {
                    return true;
                }
                return false;
            }
            return true;
        },

        translateYVal() {
            if (this.scrollTop <= 72) {
                return `translateY(${0 - this.scrollTop}px)`;
            }
            return 'translateY(-100%)';
        },
    },

    created() { },

    mounted() {
        // 01
        const menuHeight = this.$refs.menuContainer.clientHeight || 0;
        this.menuHeight = menuHeight;

        // 02
        const { clientWidth } = document.documentElement;
        this.clientWidth = clientWidth;

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                // 01
                const menuHeight = this.$refs.menuContainer.clientHeight || 0;
                this.menuHeight = menuHeight;

                // 02
                const { clientWidth } = document.documentElement;
                this.clientWidth = clientWidth;

                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 100);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },

        onClickMenu(val) {
            this.scrollTo(val);
            if (this.showMenu) {
                this.showMenu = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.menu-icon {
    display: block;
    width: 44px;
    height: 44px;
    position: relative;
}

.menu-icon span {
    position: absolute;
    width: 24px;
    height: 2px;
    top: 21px;
    left: 10px;
    background: #fff;

    border-radius: 1px;

    will-change: transform;
    transition: all 0.2s linear;
}

.menu-icon:before {
    content: '';
    display: block;
    position: absolute;
    width: 24px;
    height: 2px;

    border-radius: 1px;

    top: 11px;
    left: 10px;
    background: #fff;

    will-change: transform;
    transition: all 0.2s linear;
    transform-origin: 50% 50%;
}

.menu-icon:after {
    content: '';
    display: block;
    position: absolute;
    width: 24px;
    height: 2px;

    border-radius: 1px;

    bottom: 11px;
    left: 10px;
    background: #fff;

    will-change: transform;
    transition: all 0.2s linear;
    transform-origin: 50% 50%;
}

.show-menu .menu-icon {
    display: block;
    width: 44px;
    height: 44px;
    position: relative;
}

.show-navbar .menu-icon span,
.show-navbar .menu-icon:before,
.show-navbar .menu-icon:after {
    background: #fff;
}

.show-navbar.whitebg-navbar .menu-icon span,
.show-navbar.whitebg-navbar .menu-icon:before,
.show-navbar.whitebg-navbar .menu-icon:after {
    background: #000;
}

.show-menu .menu-icon span {
    position: absolute;
    width: 24px;
    height: 2px;

    border-radius: 1px;

    top: 21px;
    left: 10px;
    background: #000;

    opacity: 0;
}

.show-menu .menu-icon:before {
    content: '';
    display: block;
    position: absolute;
    width: 28px;
    height: 2px;

    border-radius: 1px;

    top: 21px;
    left: 8px;
    background: #000;
    transform: rotate(45deg);
    transform-origin: 50% 50%;
}

.show-menu .menu-icon:after {
    content: '';
    display: block;
    position: absolute;
    width: 28px;
    height: 2px;

    border-radius: 1px;

    bottom: 21px;
    left: 8px;
    background: #000;
    transform: rotate(-45deg);
    transform-origin: 50% 50%;
}

// pc
@media (min-width: 992px) {

    // navbar
    .navbar {
        will-change: transform;
    }

    .whitebg-navbar {
        background: #fff;
    }

    .nav-area {
        // width: 100%;
        margin: 0 -15px;

        height: 72px;
        z-index: 2;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .logo-area {
        display: flex;

        flex-direction: row;

        justify-content: space-between;

        align-items: center;
    }

    .logo {
        display: block;
        cursor: pointer;
    }

    .nav-menu {
        display: none !important;
    }

    .nav-list {
        display: flex;

        flex-direction: row;

        align-items: center;
    }

    .nav-list li {
        display: inline-block;
        padding: 10px 0;
        margin: 0 16px;
        font-size: 17px;
    }

    .nav-list li.active {
        position: relative;
        display: inline-block;
        padding: 10px 0;
        font-weight: bold;
    }

    .nav-list li.active:before {
        content: '';
        position: absolute;
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        border-radius: 2px;
        background: #fff;
    }

    .nav-list li .nav-item {
        cursor: pointer;
        color: #fff;
        text-decoration: none;
    }

    .whitebg-navbar .nav-list li.active:before {
        background: #ff3355;
    }

    .whitebg-navbar .nav-list li .nav-item {
        color: #333;
        text-decoration: none;
    }

    .social-media {
        display: flex;

        flex-direction: row;

        justify-content: flex-end;

        align-items: center;
        margin-left: 20px;
    }

    .social-media-item {
        text-decoration: none;
        cursor: pointer;
    }

    .social-media-item i {
        color: #fff;
        font-size: 32px;
    }

    .whitebg-navbar .social-media-item i {
        color: #666;
    }

    .logo {
        width: 112px;
        height: 48px;
    }
}

.menu-mask {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.62);
}

// mobile
@media (max-width: 991px) {
    .show-menu .menu-mask {
        display: block;
    }

    .logo {
        width: 112px;
        height: 48px;
    }

    // navbar
    .navbar {
        will-change: transform;
    }

    .show-menu {
        height: 100%;
    }

    .nav-area {
        // width: 100%;

        margin: 0 -15px;
        height: auto;

        z-index: 2;

        display: block;
    }

    .whitebg-navbar .nav-area-wrap,
    .show-menu .nav-area-wrap {
        position: relative;
        z-index: 2;
        background: #fff;
    }

    .nav-area-wrap {
        height: 64px;
        opacity: 1;
        overflow: hidden;

        background: transparent;

        transition: all 0.2s linear;
    }

    .show-menu .nav-area-wrap {
        height: auto;
        opacity: 1;
        overflow: hidden;

        display: flex;
        flex-direction: row;
    }

    .show-navbar .nav-area-wrap .nav-list,
    .show-navbar .nav-area-wrap .social-media {
        opacity: 0;

        transition: opacity 0.2s linear;

    }

    .show-navbar.show-menu .nav-area-wrap .nav-list,
    .show-navbar.show-menu .nav-area-wrap .social-media {
        opacity: 1;
    }

    .menu-mask {
        opacity: 0;
        transition: all 0.5s linear;
    }

    .show-menu .menu-mask {
        opacity: 1;
    }

    .logo-area {
        // width: 100%;
        min-height: 64px;
        padding: 0 4px;

        display: flex;

        flex-direction: row;

        justify-content: space-between;

        align-items: center;
    }

    .logo {
        display: block;
    }

    .nav-menu {
        display: block;
        color: #fff;
    }

    .whitebg-navbar .nav-menu,
    .show-menu .nav-menu {
        color: #000;
    }

    .nav-list {
        display: block;
        padding: 12px 0;
        // background: #fff;
        // opacity: 0;
        // transition: all 0.3s linear;
    }

    .show-menu .nav-list {
        // opacity: 1;
    }

    .nav-list li {
        display: block;
        padding: 0;
        margin: 0;
        font-size: 16px;
        border-bottom: 1px solid rgba(127, 127, 127, 0.1);

        &:last-child {
            border-bottom: 1px solid rgba(127, 127, 127, 0);
        }
    }

    .nav-list li.active {
        position: relative;
        display: block;
        padding: 0;
        font-size: 16px;
        font-weight: bold;
    }

    .nav-list li.active:before {
        content: '';
        position: absolute;
        display: block;
        left: 30px;
        top: 50%;
        margin-top: -6px;
        width: 3px;
        height: 12px;
        border-radius: 2px;
        background: #ff3355;
    }

    .nav-list li .nav-item {
        cursor: pointer;
        display: block;
        padding: 12px 44px;
        color: #fff;
        text-decoration: none;
    }

    .whitebg-navbar .nav-list li.active,
    .show-menu .nav-list li.active {
        // border-left: 2px solid #ff3355;
    }

    .whitebg-navbar .nav-list li .nav-item,
    .show-menu .nav-list li .nav-item {
        color: #333;
        text-decoration: none;
    }

    .social-media {
        padding: 12px 32px;
        display: flex;

        flex-direction: row;

        justify-content: flex-start;

        align-items: center;

        // background: #fff;
    }

    .show-menu .nav-area .nav-list {
        display: block;
    }

    .nav-area .nav-list {
        // display: none;
    }

    .show-menu .nav-area .social-media {
        display: flex;
    }

    .nav-area .social-media {
        // display: none;
    }

    .social-media-item {
        text-decoration: none;
    }

    .social-media-item i {
        color: #fff;
        font-size: 32px;
    }

    .whitebg-navbar .social-media-item i,
    .show-menu .social-media-item i {
        color: #666;
    }

    ///////////////////////
    //
    //
    //
    .menu-icon2 {
        width: 24px;
        height: 24px;
    }

    .menu-icon2 .control-icon {
        display: block;
        padding-top: 3px;
        padding-bottom: 3px;
        transition: all 0.3s ease;
    }

    .menu-icon2 .control-icon:before {
        content: '';
        display: block;
        height: 2px;
        width: 24px;
        background-color: #fff;
        // border-top-right-radius: 2px;
        // border-bottom-left-radius: 2px;
        border-radius: 1px;
        transition: transform 0.3s ease 0.2s, background-color 0.4s ease 0s;
    }

    .whitebg-navbar .menu-icon2 .control-icon:before {
        background-color: #000;
    }

    //
    //
    //
    .show-menu .menu-icon2 .control-icon:nth-child(2) {
        opacity: 0;
    }

    .show-menu .menu-icon2 .control-icon:nth-child(1) {
        transform: translateY(8px);
    }

    .show-menu .menu-icon2 .control-icon:nth-child(1):before {
        transform: rotate(45deg);
    }

    .show-menu .menu-icon2 .control-icon:nth-child(3) {
        transform: translateY(-8px);
    }

    .show-menu .menu-icon2 .control-icon:nth-child(3):before {
        transform: rotate(-45deg);
    }

    .show-menu .menu-icon2 .control-icon:before {
        background-color: #000;
    }

    ///////////////
}

.navbar {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
}

// home
.navbar.immersive {
    // TODO
    // transform: translateY(-100%) !important;
}

.navbar.show-navbar {
    transform: translateY(0) !important;
}

// !home
.navbar.down {
    transform: rotateY(0) !important;
}

.navbar.up {
    transform: rotateY(-100%) !important;
}

// common
.navbar.show-menu {
    transform: rotateY(0) !important;
}

.animation {
    transition: all 0.2s linear;
}

.nav-area-end {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.nav-area-end-mobile {
    display: flex;
    flex-direction: column;
}
</style>
